import pickBy from 'lodash/pickBy'

export default {
  setShowUploadModal: (state, showUploadModal) => {
    state.showUploadModal = showUploadModal
  },
  setShowLogoutModal: (state, showLogoutModal) => {
    state.showLogoutModal = showLogoutModal
  },
  checkFailed: (state, data) => {
    var failed = pickBy(data.ret, val => val !== 'true')
    var message = ''
    for (const key in failed) {
      message += key + ':' + failed[key] + '\n'
    }
    alert(message ? 'The following failure(s) occurred: \n' + message : data.type + ' succeeded')
  }
}
